import { useFormik } from "formik";
import { useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosComman";
import * as yup from "yup";
import { CloseIcon } from "../../../assets/icons";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FormikSelectTwo from "../../../utils/Select";
import useAddData from "../../../hooks/useAddData";
import useEditData from "../../../hooks/useEditData";

export default function CreateOrUpdate({
  data,
  visible,
  onClose,
  refreshData,
  role,
  user,
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [createNew, setCreateNew] = useState({
    userId: "",
    roleId: "",
  });

  useEffect(() => {
    data &&
      setCreateNew({
        userId: data?.userId,
        roleId: data?.roleId,
      });
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      userId: yup.string().required("select is required"),
      roleId: yup.string().required("status is rquierd"),
    }),
    onSubmit: (value, { resetForm }) => {
      //   setIsLoading(true);
      if (data?.userRoleId) {
        data.userId = value.userId;
        data.roleId = value.roleId;
        editData({
          url: `/User-Role/${data?.userRoleId}`,
          value: value,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      } else {
        addData({
          url: "/User-Role/",
          value: value,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      }
    },
  });

  if (!visible) return null;
  const resetClose = () => {
    formik.resetForm();
    onClose();
  };
  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center  h-auto"
      >
        <div className="bg-white mt-12 p-2 h-auto rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative px-6 max-h-44 flex flex-wrap justify-between text-left">
              <FormikSelectTwo
                formik={formik}
                name="userId"
                label="User"
                width="w-1/2"
                placeholder="Select User"
                Options={user.map((i) => {
                  return {
                    value: i.userId,
                    label: i.name || i.user_name,
                  };
                })}
                isDisabled={data?true:false}
              />
              <FormikSelectTwo
                formik={formik}
                name="roleId"
                label="Role"
                width="w-1/2"
                placeholder="Select Role"
                Options={role.map((i) => {
                  return {
                    value: i.roleId,
                    label: i.roleName,
                  };
                })}
              />
              <div className=" w-full flex items-center justify-end px-6 py-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
